import { Box, Skeleton, Divider } from '@mui/material';

export const NewsSkeletons = (count: number) => (
  <>
    {[...Array(count)].map((_, index) => (
      <Box
        key={`skeleton-${index}`}
        sx={{
          width: '220px',
          flexShrink: 0,
          height: '118px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 1,
            width: '100%',
          }}
        >
          <Skeleton
            variant='text'
            width={80}
            height={20}
            sx={{
              transform: 'scale(1, 0.8)',
            }}
          />
          <Divider sx={{ flexGrow: 1, ml: 1 }} />
        </Box>
        <Skeleton
          variant='text'
          height={96}
          sx={{
            transform: 'scale(1, 1)',
          }}
        />
      </Box>
    ))}
  </>
);
